export const mapBackendToForm = (data) => {
  if (!data) return {};
  return {
    ...data,
    general_anaesthesia: !!data.general_anaesthesia,
    spinal_epidural_with_sedation: !!data.spinal_epidural_with_sedation,
    spinal_epidural_without_sedation: !!data.spinal_epidural_without_sedation,
    major_minor_nerve_with_sedation: !!data.major_minor_nerve_with_sedation,
    major_minor_nerve_without_sedation: !!data.major_minor_nerve_without_sedation,
  };
};

export const mapFormToBackend = (formData) => {
  return {
    ...formData,
    hospital_id: 1,
    general_anaesthesia: formData.general_anaesthesia ? 1 : 0,
    spinal_epidural_with_sedation: formData.spinal_epidural_with_sedation ? 1 : 0,
    spinal_epidural_without_sedation: formData.spinal_epidural_without_sedation ? 1 : 0,
    major_minor_nerve_with_sedation: formData.major_minor_nerve_with_sedation ? 1 : 0,
    major_minor_nerve_without_sedation: formData.major_minor_nerve_without_sedation ? 1 : 0,
  };
};
